// extracted by mini-css-extract-plugin
module.exports = {"bannerMoreInfo":"styles_bannerMoreInfo__2kMhx","rightarrow":"styles_rightarrow__1aMPL","bannerText":"styles_bannerText__3halu"};